import ErrorBoundary from 'components/ErrorBoundary'
import React from 'react'
import { Card, CardBody, CardHeader, CardTitle, Col, Nav, Row } from 'reactstrap'
import CTooltip from "react-tooltip-lite";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
  } from "chart.js";
  import { Line } from "react-chartjs-2";
import DownloadCSVButton from './DownloadCsv';
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
  );
  
  ChartJS.register(ArcElement, Tooltip, Legend);
  
  const plugin = {
    beforeInit(chart) {
      // Get reference to the original fit function
      const originalFit = chart.legend.fit;
  
      // Override the fit function
      chart.legend.fit = function fit() {
        // Call original function and bind scope in order to use `this` correctly inside it
        originalFit.bind(chart.legend)();
        // Change the height as suggested in another answers
        this.height = this.height + 15;
      };
    },
  };
  
  export const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          color: "#000",
          size: 15,
        },
      },
      y: {
        ticks: {
          callback: function (value, index, ticks) {
            return "$" + value + "k";
          },
        },
        border: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          padding: 15,
          usePointStyle: true,
          pointStyle: "rect",
          color: "#707070",
          font: {
            size: 14,
            weight: "600",
          },
        },
        align: "start",
      },
    },
  };
const WacInpact = (props) => {
  const {selectsearch}=props

    const copyData = {
      labels: ["Dec","Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov"],
        datasets:selectsearch==true? [
          {
            label: "WAC",
            data: [300,500,750,821,967,357,678,721,889,345,175,267],
            borderColor: "#702C62",
            backgroundColor: "#702C62",
            pointRadius: 3.5,
          },
         
         
        ]:[],
        
      };
  return (
    <div>
         <ErrorBoundary>
      <Card className="p-3 h-100 border-0 shadow-top">
        <CardHeader className="border-0 bg-white px-0 pt-0" style={{ paddingBottom: "0px" }}>
          <Row className="align-items-center">
            <Col>
                       {/* <CTooltip
                         content={
                           <div className="tip-list-info">
                             <p>
                               The number of claims that captured and replenished by
                               month.
                             </p>
                           </div>
                         }
                       > */}
                         
                       {/* </CTooltip> */}
                       <CardTitle className="f-20 font-weight-600 dashboard-headings">
                           <div className="d-flex justify-content-between align-items-center top_left_hed pb-1 graph-headings">
                            WAC Impact
                             <DownloadCSVButton
monthsdata={[]}
valuedata1={[]}
valuedata2={[]}
                               heading1={["Months", "Captured", "Replenished"]}
                               filenamedata={"Captured_Replenished"}
                               download={false}

                             />
                             {/* <img src={Download} /> */}
                             
                           </div>
                         </CardTitle>
                     </Col>
            <Col xs="auto" >
              <Nav className="widget-tabs"></Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className="dashboard-chart-body p-0">
       
          <div className="chat-container">
            <Line options={options} data={copyData} plugins={[plugin]} />
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
    </div>
  )
}

export default WacInpact